import { render } from "./VncView.vue?vue&type=template&id=25a4d40c&scoped=true&ts=true"
import script from "./VncView.vue?vue&type=script&lang=ts"
export * from "./VncView.vue?vue&type=script&lang=ts"

import "./VncView.vue?vue&type=style&index=0&id=25a4d40c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a4d40c"]])

export default __exports__